import {
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  TextField,
  Button,
  InputLabel,
  Box
} from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import '../../pages/Sensors/sensors.scss';

interface Props {
  showChangeMail: boolean;
  closeModal: () => void;
  handleSubmit: Function;
  setNewMail:Function;
  setIncludeLicense: Function
}

const ChangeMailModal = ({
  showChangeMail,
  closeModal,
  handleSubmit,
  setNewMail,
  setIncludeLicense
}: Props) => {
  const { t } = useTranslation();
  return (
    <Dialog className='dialog' open={showChangeMail} onClose={closeModal}>
      <DialogTitle className="dialogTitle">
        {t('CHANGE_MAIL_SENSOR')}
      </DialogTitle>

      <DialogContent>
        <Box sx={{ height: 20 }}></Box>
        <InputLabel>{t('NEW_MAIL')}</InputLabel>
        <TextField
        sx={{
          '& legend': { display: 'none' },
          '& fieldset': { top: 0 }
        }}
          size='small'
          required
          fullWidth
          type='email'
          onChange={(e) => setNewMail(e.target.value)}
          id="newMail"
        />
        <FormControlLabel
          control={<Checkbox id='includeLicense' onChange={(e) => setIncludeLicense(e.target.checked)} />}
          label={t('INCLUDE_LICENSE')}
        />
        <DialogActions>
          <Button variant="contained" onClick={() => handleSubmit()}>
            {t('CHANGE')}
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};

export default ChangeMailModal;
